module.exports = __webpack_public_path__ + "hotpFactor_70x70.edcf938b4d766e6ad4f2dbad4a556ea9.png";